"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _authInformation = require("@/api/authInformation");
var _validate = require("@/utils/validate");
var _permission = require("@/utils/permission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'index',
  data: function data() {
    return {
      baseUrl: 'https://shop.crmeb.net/html/index.html',
      iframeUrl: '',
      captchs: 'http://authorize.crmeb.net/api/captchs/',
      authCode: '',
      status: null,
      dayNum: 0,
      copyright: '',
      isTemplate: false,
      price: '',
      proPrice: '',
      productStatus: false,
      copyForm: {
        companyName: '',
        companyImage: ''
      },
      success: false,
      payType: '',
      disabled: false,
      isShow: false,
      // 验证码模态框是否出现
      active: 0,
      timer: null,
      version: '',
      label: '',
      productType: '',
      modalPic: false,
      isChoice: '单选',
      gridPic: {
        xl: 6,
        lg: 8,
        md: 12,
        sm: 12,
        xs: 12
      },
      gridBtn: {
        xl: 4,
        lg: 8,
        md: 8,
        sm: 8,
        xs: 8
      },
      title: '',
      rules: {
        companyName: [{
          required: true,
          message: '请输入版权信息',
          trigger: 'blur'
        }],
        companyImage: [{
          required: true,
          message: '请上传版权图片',
          trigger: 'change'
        }]
      },
      loading: false,
      domainUrl: ''
    };
  },
  mounted: function mounted() {
    var _this2 = this;
    if ((0, _permission.checkPermi)(['admin:copyright:get:info'])) this.getAuth();
    window.addEventListener('message', function (e) {
      if (e.data.type == 'onComplete') {
        _this2.handleClose();
      }
    });
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 选择图片
    modalPicTap: function modalPicTap() {
      var _this = this;
      this.$modalUpload(function (img) {
        _this.copyForm.companyImage = img[0].sattDir;
      });
    },
    //删除授权图片
    handleRemove: function handleRemove() {
      this.copyForm.companyImage = '';
    },
    toCrmeb: function toCrmeb() {
      window.open('http://www.crmeb.com');
    },
    handleClose: function handleClose() {
      this.getAuth();
      this.iframeUrl = '';
      this.isTemplate = false;
    },
    // 申请授权
    applyAuth: function applyAuth(product) {
      this.productType = product;
      this.title = product === 'copyright' ? '去版权' : '商业授权';
      var host = location.host;
      var hostData = host.split('.');
      if (hostData[0] === 'test' && hostData.length === 4) {
        host = host.replace('test.', '');
      } else if (hostData[0] === 'www' && hostData.length === 3) {
        host = host.replace('www.', '');
      }
      this.iframeUrl = this.baseUrl + '?url=' + this.domainUrl + '&product=' + product + '&version=' + this.version + '&label=' + this.label;
      this.isTemplate = true;
    },
    getAuth: function getAuth() {
      var _this3 = this;
      (0, _authInformation.copyrightInfoApi)().then(function (res) {
        var data = res || {};
        _this3.label = data.label;
        _this3.version = data.version;
        _this3.authCode = data.authCode || '';
        _this3.status = data.status;
        _this3.copyright = data.copyright;
        _this3.copyForm.companyName = data.companyName;
        _this3.copyForm.companyImage = data.companyImage;
        _this3.domainUrl = data.domainUrl && data.domainUrl.indexOf('https://') !== -1 ? data.domainUrl.slice(8) : data.domainUrl;
      });
    },
    //保存版权信息
    saveCopyRight: (0, _validate.Debounce)(function (form) {
      var _this4 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        (0, _authInformation.saveCrmebCopyRight)(_this4.copyForm).then(function (res) {
          _this4.$message.success('保存成功');
          _this4.getAuth();
        });
      });
    })
  }
};